/*@flow*/
// @ts-check
/** @jsx jsx */
import { jsx } from '@emotion/core';
import useContextState from 'comps/Left2/useContextState';
import Folio from 'lib/folio';

export function Canvas() {
  const s1 = useContextState();
  const { decks, schema, loading } = s1;
  return (
    <Folio name="cityMap" decks={decks} schema={schema} loading={loading} />
  );
}
